const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
console.log("API URL", process.env.REACT_APP_API_URL);

// Base HTTP client
const httpClient = {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        // Add Bearer token if available and not already provided
        ...(token && !options.headers?.Authorization ? { 'Authorization': `Bearer ${token}` } : {}),
        ...options.headers,
      },
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  },

  get(endpoint, headers = {}) {
    return this.request(endpoint, { method: 'GET', headers: headers });
  },

  post(endpoint, body, headers = {}) {
    return this.request(endpoint, { method: 'POST', body, headers });
  },

  put(endpoint, body, headers = {}) {
    return this.request(endpoint, { method: 'PUT', body, headers });
  },

  delete(endpoint, headers = {}) {
    return this.request(endpoint, { method: 'DELETE', headers });
  },
};

// API client with your current endpoints
const apiClient = {
  // Root endpoint
  root: {
    get: () => httpClient.get('/'),
  },

  // Test database endpoint
  testDb: {
    get: () => httpClient.get('/test-db'),
  },

  // Authentication endpoints
  auth: {
    register: (userData) => httpClient.post('/auth/register', userData),
    login: (credentials) => httpClient.post('/auth/login', credentials),
    me: () => httpClient.get('/auth/me'),
  },

  // User profile endpoints
  profile: {
    update: (profileData) => httpClient.put('/users/profile', profileData),
    delete: () => httpClient.delete('/users/profile'),
  },
};

export default apiClient;